export default __webpack_public_path__ + "static/media/ribbed_non_roll.eaede319.jpg";